import { z } from "zod";
import { PRICING } from "../constants/pricing";

export const topupSchema = z.object({
  amount: z
    .number()
    .min(PRICING.minTopup, `Minimum top-up is $${PRICING.minTopup}`)
    .max(1000, "Maximum top-up is $1,000"),
});

export type TopupInput = z.infer<typeof topupSchema>;
